import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { Notice } from 'actions/actionTypes';
import * as actions from 'actions/customerService/notice';

import {
    callNoticeList,
    callNoticeInfo,
} from 'network/apis/customerService/notice';

// 게시판 글 목록 조회 사가 함수
function* loadNoticeListRequestSaga() {
    try {
        const notice = yield select((state) => state.notice);

        var data = {
            SearchStartDate: notice.searchFilter.searchStartDate,
            Page: notice.searchFilter.page,
            PageSize: notice.searchFilter.pageSize,
            PostCoverage: [0, 1], 
            PostTypeCode: notice.searchFilter.postTypeCode,
            SearchText: notice.searchFilter.searchText,
            isView: true,
        };

        const response = yield call(callNoticeList, data);

        yield put(actions.loadNoticeListSuccess(response.data));
    } catch (error) {
        yield put(actions.loadNoticeListFailure(error.message));
    }
}

// 문의 정보 조회 사가 함수
function* loadNoticeInfoRequestSaga() {
    try {
        const notice = yield select((state) => state.notice);

        const response = yield call(callNoticeInfo, notice.noticeInfo.idx);

        yield put(actions.loadNoticeInfoSuccess(response.data));
    } catch (error) {
        yield put(actions.loadNoticeInfoFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(Notice.LOAD_NOTICE_LIST_REQUEST, loadNoticeListRequestSaga),
        takeLatest(Notice.LOAD_NOTICE_INFO_REQUEST, loadNoticeInfoRequestSaga),
    ]);
}
